<template>
  <div class="form_button_container">
    <button class="FormButton" type="button" v-if="!isLoading" @click="$emit('click')">
      {{ $t(label) }}
    </button>
    <Loader v-else v-bind:text="$t(loadingText)"></Loader>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'

export default {
  name: 'ValidateFormButton',
  props: {
    label: {
      type: String,
      default: 'forms.default-cta'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: 'global.loading'
    }
  },
  components: {
    Loader
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/responsive.scss';

.form_button_container {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.FormButton {
  margin-bottom: 14px;
  min-width: 200px;
  height: 40px;
  border-radius: 30px;
  background-color: $primary;
  color: $font-button;
  box-shadow: unset;
  border: unset;
  font-weight: bold;
  font-size: 20px;
  padding: 0 10px 0 10px;

  @include for-size(phone-only) {
    min-width: 100px;
  }

  &:hover {
    cursor: pointer;
  }
}
.ValidateFormButton-Bis {
  button {
    min-width: 300px;

    @include for-size(phone-only) {
      min-width: 200px;
    }
  }
}

.container-mobile {
  button {
    font-size: 1rem;
  }
}

.ValidateFormButton-Purple button {
  background-color: $primary !important;
}
</style>
